import { render, staticRenderFns } from "./ReportSection.vue?vue&type=template&id=10bf96f3&scoped=true"
import script from "./ReportSection.vue?vue&type=script&lang=js"
export * from "./ReportSection.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ReportSection.vue?vue&type=style&index=1&id=10bf96f3&prod&scoped=true&lang=css"
import style2 from "./ReportSection.vue?vue&type=style&index=2&id=10bf96f3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bf96f3",
  null
  
)

export default component.exports